import React from 'react'
import FormGroup from '@material-ui/core/FormGroup'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Checkbox from '@material-ui/core/Checkbox'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
   listContainer: {
      marginBottom: 24
   }
}))

const CheckboxesGroup = ({ items, handleSelection, parentOptionId }) => {
   const classes = useStyles()
   const itemIds = items && Object.keys(items)
   return (
      <FormGroup className={classes.listContainer}>
         {itemIds &&
            itemIds.length &&
            itemIds.map(itemId => {
               const item = items[itemId]
               let checkboxName = itemId
               if (parentOptionId) {
                  checkboxName = `${parentOptionId}_${itemId}`
               }
               return (
                  <FormControlLabel
                     key={itemId}
                     control={
                        <Checkbox
                           checked={item.checked}
                           onChange={handleSelection}
                           name={checkboxName}
                           color="primary"
                        />
                     }
                     label={item.name}
                  />
               )
            })}
      </FormGroup>
   )
}

export default CheckboxesGroup
